module.exports = __webpack_public_path__ + "static/circle-of-the-moon-druid-mtg_afr-dddb5930c36a641ec35632e28e308ded.jpg";